var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.295,
    viewBox: "0 0 18 15.295"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "store",
    d: "M17.648,3.543,15.751.448A.931.931,0,0,0,14.959,0H3.152A.931.931,0,0,0,2.36.448L.464,3.543A2.678,2.678,0,0,0,2.182,7.618a2.972,2.972,0,0,0,.4.027,2.859,2.859,0,0,0,2.157-.989,2.846,2.846,0,0,0,4.314,0,2.846,2.846,0,0,0,4.314,0,2.868,2.868,0,0,0,2.157.989,2.94,2.94,0,0,0,.4-.027A2.676,2.676,0,0,0,17.648,3.543ZM15.529,8.6a3.632,3.632,0,0,1-.862-.114v2.981H3.445V8.49a3.792,3.792,0,0,1-.862.114,3.859,3.859,0,0,1-.526-.036,3.607,3.607,0,0,1-.479-.108v5.879a.945.945,0,0,0,.935.956H15.6a.945.945,0,0,0,.935-.956V8.46a2.928,2.928,0,0,1-.479.108,3.977,3.977,0,0,1-.532.036Z",
    transform: "translate(-0.056)"
  })));
};
export default SvgStore;